import { api } from '../../lib/api-client';

export type TalentSkillDetail = {
  name: string;
  level: string | null;
  yearsOfExperience: number | null;
};

export type TalentDetail = {
  /**
   * `Candidate.PublicKey` (Guid). El backend nunca expone la PK secuencial al
   * cliente (ADR-007 / SW-407).
   */
  id: string;
  fullName: string;
  currentCompany: string | null;
  seniority: string | null;
  country: string | null;
  city: string | null;
  profilePhotoId: string | null;
  availableFrom: string | null;
  skills: TalentSkillDetail[];
  // SW-141 Phase 1: campos del Candidate ya existentes pero recién expuestos.
  // El BE aplica visibility toggles ShowBio/ShowDomain/ShowRole — null cuando
  // el cliente no debería verlos.
  bio: string | null;
  domain: string | null;
  role: string | null;
  // SW-141 Phase 1: scalars nuevos. Sin visibility toggles aún (default visible).
  // hourlyRate en USD/hr (selling rate, NO salario personal). vettingScore 0-100.
  hourlyRate: number | null;
  vettingScore: number | null;
  isVerified: boolean;
};

export type GetTalentDetailParams = {
  /** `Project.PublicKey` (Guid string) — el shortlist context. */
  shortlistPublicKey: string;
  /** `Candidate.PublicKey` (Guid string). */
  talentPublicKey: string;
};

export async function getTalentDetail(params: GetTalentDetailParams): Promise<TalentDetail> {
  const url = `/api/client/shortlists/${params.shortlistPublicKey}/talents/${params.talentPublicKey}`;
  return api.get<TalentDetail>(url);
}
